import type { DogFormData, Recipe } from '../types';
import type { PetSnapshot } from '../types/pets';

interface PlanData {
  distribution: Record<string, number>;
  discountedInitiationPrice: number;
  monthlyPrice: number;
  sizeChoice: Record<string, string>;
}

// distribution is keyed by canonical product.id (UUID); match recipes by productId.
function buildVariantNameMap(distribution: Record<string, number>, recipes: Recipe[]): Record<string, string> {
  const names: Record<string, string> = {};
  for (const productId of Object.keys(distribution)) {
    const recipe = recipes.find(
      (r) =>
        String(r.productId) === productId ||
        (r.variants && Object.values(r.variants).some((v) => String(v.productId) === productId)),
    );
    if (recipe) names[productId] = recipe.name;
  }
  return names;
}

export function buildPetSnapshot(formData: Partial<DogFormData>, planData: PlanData, recipes?: Recipe[]): PetSnapshot {
  const recipeNames =
    recipes && Object.keys(planData.distribution).length > 0
      ? buildVariantNameMap(planData.distribution, recipes)
      : undefined;

  return {
    id: `pet-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
    nombre: formData.nombre || 'Mascota',
    raza: formData.raza || null,
    peso: formData.peso || 0,
    formData: {
      ...formData,
      initiationPackDistribution: planData.distribution,
      initiationPackPrice: planData.discountedInitiationPrice,
      monthlyPlanPrice: planData.monthlyPrice,
      ...(Object.keys(planData.sizeChoice).length > 0 ? { sizeChoice: planData.sizeChoice } : {}),
    } as DogFormData,
    pricing: {
      initiationPrice: planData.discountedInitiationPrice,
      monthlyDiscountedPrice: planData.monthlyPrice,
    },
    ...(recipeNames && Object.keys(recipeNames).length > 0 ? { recipeNames } : {}),
    completedAt: new Date().toISOString(),
  };
}
